export type AppEnvironment = 'dev' | 'test' | 'prod'

function normalizeEnvironment(mode: string): AppEnvironment {
  switch (mode.trim().toLowerCase()) {
    case 'dev':
    case 'development':
      return 'dev'
    case 'test':
      return 'test'
    case 'prod':
    case 'production':
      return 'prod'
    default:
      throw new Error(`Unsupported frontend environment mode: ${mode || '(empty)'}`)
  }
}

function parseBoolean(value: string | undefined, name: string, fallback = false): boolean {
  const normalized = value?.trim().toLowerCase()
  if (!normalized) return fallback
  if (normalized === 'true') return true
  if (normalized === 'false') return false
  throw new Error(`${name} must be either "true" or "false"`)
}

function normalizeApiBaseUrl(value: string | undefined): string {
  return (value || '').trim().replace(/\/+$/, '')
}

function normalizeRouterBase(value: string | undefined): string {
  const normalized = (value || '/').trim()
  if (!normalized || normalized === '/') return '/'
  return `/${normalized.replace(/^\/+|\/+$/g, '')}/`
}

const environment = normalizeEnvironment(import.meta.env.MODE)

export const appConfig = Object.freeze({
  environment,
  apiBaseUrl: normalizeApiBaseUrl(import.meta.env.VITE_APP_BASE_API),
  routerBase: normalizeRouterBase(import.meta.env.VITE_ROUTER_BASE),
  apiDebug: parseBoolean(import.meta.env.VITE_API_DEBUG, 'VITE_API_DEBUG'),
  feedbackAssistantToken: (import.meta.env.VITE_FEEDBACK_ASSISTANT_TOKEN || '').trim(),
  trackServerUrl: (import.meta.env.VITE_TRACK_SERVER_URL || '').trim(),
  trackAppKey: (import.meta.env.VITE_TRACK_APP_KEY || '').trim(),
  trackDebug: parseBoolean(import.meta.env.VITE_TRACK_DEBUG, 'VITE_TRACK_DEBUG'),
  isDev: environment === 'dev',
  isTest: environment === 'test',
  isProd: environment === 'prod'
})
